export const aiChatKeys = {
  all: [{ module: 'aiChat' }] as const,
  details: () => [{ ...aiChatKeys.all[0], scope: 'detail' }] as const,
  detail: (kind: 'repository' | 'transcript', id: string) => [{ ...aiChatKeys.details()[0], kind, id }] as const,
};
